module.exports = __webpack_public_path__ + "img/l3-bird-back.18801bc3.png";